module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-top": "100px"
    },
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('p', [_vm._v("My second worst nightmare is that I have to sit my higher mathematics again, and I know nothing.")]), _vm._v(" "), _c('p', [_vm._v("And I mean nothing.")]), _vm._v(" "), _c('p', [_vm._v("Nothing.")]), _vm._v(" "), _c('p', [_vm._v("Have got used to that word throughout life and its variation: nothingness.")]), _vm._v(" "), _c('p', [_vm._v("My own personal nightmare follows on from that.")]), _vm._v(" "), _c('p', [_vm._v("It all stems from not being.")]), _vm._v(" "), _c('p', [_vm._v("And not nothingness.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc24252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0002.vue
// module id = 75
// module chunks = 0